import type { ReactNode } from 'react';
import { cn } from '@rocco/utils/cn';

export interface SectionLabelProps {
    /** Eyebrow text, e.g. "(01 – Projects)", "(About)", "(04 – Articles)". */
    children: ReactNode;
    className?: string;
}

/**
 * Small eyebrow label that prefixes homepage sections (Neue Haas Roman, 2rem on
 * desktop and 0.5718rem below it — 9.15px at the 414px mobile design width,
 * which is what the old `2.21vw` resolved to there. In rem rather than vw so
 * it holds its proportion to the rem-sized copy beside it at any width; the
 * two only matched at 414, and the label overran its indent above it.
 *
 * Switches at `lg`, the boundary the desktop tree starts at. Defaults to the dark ink colour; pass
 * `text-white` via className on dark sections. Positioning and any per-section
 * size override are left to the consuming section.
 */
export const SectionLabel = ({ children, className }: SectionLabelProps) => (
    <span
        className={cn(
            'font-sans leading-[1.07] font-normal tracking-[-0.044em] text-[#181818] max-lg:text-[0.5718rem] lg:text-8',
            className,
        )}
    >
        {children}
    </span>
);
